import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=cdf9c1d2&"
import script from "./Paper.vue?vue&type=script&lang=js&"
export * from "./Paper.vue?vue&type=script&lang=js&"
import style0 from "./Paper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports